import React, {
    createContext,
    PropsWithChildren,
    useContext,
    useState,
    ConsumerProps,
} from "react";

type landingContextType = {
    isOpenedquotationPopup: boolean;
    setOpenedQuotationPopup: (value: boolean) => void;
    isOpenedPayrollModal: boolean;
    setOpenedPayrollModal: (val: boolean) => void;
};

export const landingContext = createContext<landingContextType>(null);

export const useLanding = () => useContext(landingContext);

export const LandingProvider: React.FC<PropsWithChildren<unknown>> = (
    props: PropsWithChildren<unknown>
) => {
    const [isOpenedquotationPopup, setOpenedQuotationPopup] = useState(false);
    const [isOpenedPayrollModal, setOpenedPayrollModal] = useState(false);
    return (
        <landingContext.Provider
            value={{
                isOpenedquotationPopup,
                setOpenedQuotationPopup,
                isOpenedPayrollModal,
                setOpenedPayrollModal,
            }}
        >
            {props.children}
        </landingContext.Provider>
    );
};

export const LandingConsumer: React.FC<ConsumerProps<landingContextType>> = (
    props: ConsumerProps<landingContextType>
) => <landingContext.Consumer>{props.children}</landingContext.Consumer>;
